export default __webpack_public_path__ + "static/media/local_restaurantrestaurant_menu.6509935b.svg";